import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

const HintButtonComponent = ({
  id,
  hintType,
  active,
  onClick,
  buttonBackground,
  buttonBackgroundPressed,
  buttonBackgroundHovered,
  iconColour,
  iconColourPressed
}) => {
  const [hovered, setHovered] = useState(false);

  let backgroundColor;
  if (active) {
    backgroundColor = buttonBackgroundPressed;
  } else if (hovered) {
    backgroundColor = buttonBackgroundHovered;
  } else {
    backgroundColor = buttonBackground;
  }

  const buttonStyle = {
    backgroundColor
  };

  return (
    <button
      id={ id }
      type="button"
      onClick={ () => onClick() }
      className="hint-button"
      style={ buttonStyle }
      onMouseEnter={ () => setHovered(true) }
      onMouseLeave={ () => setHovered(false) }
    >
      <svg className="svg-icon" style={ { fill: active ? iconColourPressed : iconColour } }>
        <use xlinkHref={ `assets/images/hint-defs.svg#${ hintType }-icon` } />
      </svg>
    </button>
  );
};

HintButtonComponent.propTypes = {
  id: PropTypes.string,
  hintType: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  buttonBackground: PropTypes.string,
  buttonBackgroundPressed: PropTypes.string,
  buttonBackgroundHovered: PropTypes.string,
  iconColour: PropTypes.string,
  iconColourPressed: PropTypes.string
};

HintButtonComponent.defaultProps = {
  buttonBackground: 'rgba(255, 255, 255, .75)',
  buttonBackgroundPressed: '#1f3460',
  buttonBackgroundHovered: 'rgba(255, 255, 255, .75)', // Same value as buttonBackground so there's no change when hovering by default
  iconColour: '#1f3460',
  iconColourPressed: '#fff',
  id: null
};

export default HintButtonComponent;
